<template>
  <v-container class="pt-0">
    <v-row justify="center">
      <v-dialog
        v-model="open"
        persistent
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="closeDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Datos de la Carrera</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark text color="warning" @click.stop="deleteDlg = true">
                <v-icon class="mr-2">mdi-delete-forever</v-icon> Eliminar
              </v-btn>

              <v-btn dark text @click="saveDialog">
                <v-icon class="mr-2">mdi-content-save-edit</v-icon> Guardar
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="7">
                  <v-text-field
                    label="Nombre de la carrera"
                    required
                    v-model="datos.nombre"
                  />
                </v-col>
                <v-col cols="7" sm="3">
                  <v-text-field
                    label="Plan de Estudios"
                    required
                    v-model="datos.plan_estudios"
                  />
                </v-col>
                <v-col cols="5" sm="2">
                  <v-select
                    v-model="datos.activo"
                    :items="[
                      { text: 'SI', value: '1' },
                      { text: 'NO', value: '0' },
                    ]"
                    label="Vigente"
                    required
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="deleteDlg" persistent max-width="500">
        <v-card>
          <v-card-title class="headline"> Confirma Eliminación </v-card-title>
          <v-card-text
            >Por favor confirma que deseas eliminar el registro de esta
            Carrera.</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="deleteDlg = false"> Cancelar </v-btn>
            <v-btn color="red darken-1" text @click="deleteDialog">
              Eliminar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "CarreraEdit",

  props: {
    open: Boolean,
    datos: Object,
  },

  data: () => ({
    dialog: false,
    deleteDlg: false,
  }),

  methods: {
    closeDialog() {
      this.$emit("exit");
    },

    deleteDialog() {
      this.deleteDlg = false;
      this.$emit("delete");
    },

    saveDialog() {
      this.$emit("save");
    },
  },

  mounted() {},
};
</script>
